import React from "react";
import "bootstrap/dist/css/bootstrap.css";


// CSS
import "./styles/PrivacyPolicy.css";


const PrivacyPolicy = () => {
  return (
    <>
      <div className="container-fluid container-privacypolicy-CSS">
        <h1 className="privacypolicy-h1-CSS">
          The MERN-Society-CMS Privacy Notice
        </h1>

        <h3 className="privacypolicy-h2-CSS">Introduction</h3>
        <ol className="privacypolicy-ol-CSS">
          <li>
            This is a notice to inform you of our policy about all information
            that we record about you. It sets out the conditions under which we
            may process any information that we collect from you, or that you
            provide to us. It covers information that could identify you
            (“personal information”) and information that could not. In the
            context of the law and this notice, “process” means collect, store,
            transfer, use or otherwise act on information.
          </li>
          <li>
            We regret that if there are one or more points below with which you
            are not happy, your only recourse is to leave our website
            immediately.
          </li>
          <li>
            We take seriously the protection of your privacy and confidentiality.
            We understand that all visitors to our website are entitled to know
            that their personal data will not be used for any purpose unintended
            by them and will not accidentally fall into the hands of a third party.
          </li>
          <li>
            We undertake to preserve the confidentiality of all information you
            provide to us and hope that you reciprocate.
          </li>
          <li>
            The law requires us to tell you about your rights and our
            obligations to you in regards to the processing and control of your
            personal data. We do this now, by requesting that you read the
            information provided at knowyourprivacyrights.org.
          </li>
          <li>
            Except as set out below, we do not share, or sell, or disclose to a
            third party, any information collected through our website.
          </li>
        </ol>

        <h3 className="privacypolicy-h2-CSS">
          The basis on which we process information about you
        </h3>
        <p className="privacypolicy-p-CSS">
          The law requires us to determine under which of six defined basis we
          process different categories of your personal information and to
          notify you of the basis for each category.
        </p>
        <p className="privacypolicy-p-CSS">
          If a basis on which we process your personal information is no longer
          relevant then we shall immediately stop processing your data.
        </p>
        <p className="privacypolicy-p-CSS">
          If the basis changes then if required by law we shall notify you of
          the change and of any new basis under which we have determined that we
          can continue to process your information.
        </p>

        <ol className="privacypolicy-ol-CSS">
          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Information we process because we have a contractual obligation
              with you
            </h3>
          </li>
          <p>
            When you commission us for a consultation or service, or otherwise
            agree to our terms and conditions, a contract is formed between you
            and us.
          </p>
          <p>
            In order to carry out our obligations under that contract we must
            process the information you give us. Some of this information may be
            personal information.
          </p>
          <p>We may use it in order to:</p>
          <ul className="privacypolicy-ul-CSS">
            <li>verify your identity for security purposes</li>
            <li>sell products to you</li>
            <li>provide you with our services</li>
            <li>
              provide you with suggestions and advice on products, services and
              how to obtain the most from using our website
            </li>
          </ul>
          <p>
            We process this information on the basis there is a contract between
            us, or that you have requested we use the information before we
            enter into a legal contract.
          </p>
          <p>
            Additionally, we may aggregate this information in a general way and
            use it to provide class information, for example to monitor our
            performance with respect to a particular service we provide. If we
            use it for this purpose, you as an individual will not be personally
            identifiable.
          </p>
          <p>
            We shall continue to process this information until the contract
            between us ends or is terminated by either party under the terms of
            the contract.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Information we process with your consent
            </h3>
          </li>
          <p>
            Through certain actions when otherwise there is no contractual
            relationship between us, such as when you browse our website or ask
            us to provide you more information about our business, including our
            products and services, you provide your consent to us to process
            information that may be personal information.
          </p>
          <p>
            Wherever possible, we aim to obtain your explicit consent to process
            this information, for example, by asking you to agree to our use of
            cookies.
          </p>
          <p>
            Sometimes you might give your consent implicitly, such as when you
            send us a message by e-mail to which you would reasonably expect us
            to reply.
          </p>
          <p>
            Except where you have consented to our use of your information for a
            specific purpose, we do not use your information in any way that
            would identify you personally. We may aggregate it in a general way
            and use it to provide class information, for example to monitor the
            performance of a particular page on our website.
          </p>
          <p>
            If you have given us explicit permission to do so, we may from time
            to time pass your name and contact information to selected
            associates whom we consider may provide services or products you
            would find useful.
          </p>
          <p>
            We continue to process your information on this basis until you
            withdraw your consent or it can be reasonably assumed that your
            consent no longer exists.
          </p>
          <p>
            You may withdraw your consent at any time by instructing us
            example@gmail.com. However, if you do so, you may not be
            able to use our website or our services further.
          </p>
          <p>
            We may offer an email opt in regarding further communication between
            you and us. We may publish a news letter, blog posts or direct
            emails to you when you opt in by giving us your email address. By
            agreeing to opt in, by agreeing to our terms and privacy policy you
            have agreed to this kind of communication.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Information we process for the purposes of legitimate interests
            </h3>
          </li>
          <p>
            We may process information on the basis there is a legitimate
            interest, either to you or to us, of doing so.
          </p>
          <p>
            Where we process your information on this basis, we do after having
            given careful consideration to:
          </p>
          <ul className="privacypolicy-ul-CSS">
            <li>
              whether the same objective could be achieved through other
              meanswhether the same objective could be achieved through other
              means
            </li>
            <li>whether processing (or not processing) might cause you harm</li>
            <li>
              whether you would expect us to process your data and whether you
              would, in the round, consider it reasonable to do so
            </li>
          </ul>
          <p>
            For example, we may process your data on this basis for the purposes of:
          </p>
          <ul className="privacypolicy-ul-CSS">
            <li>
              record-keeping for the proper and necessary administration of our
            </li>
            <li>
              responding to unsolicited communication from you to which we
              believe you would expect a response
            </li>
            <li>protecting and asserting the legal rights of any party</li>
            <li>
              insuring against or obtaining professional advice that is required
              to manage organisational or business risk
            </li>
            <li>
              protecting your interests where we believe we have a duty to do
              so.
            </li>
          </ul>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Information we process because we have a legal obligation
            </h3>
            <p>
              We are subject to the law like everyone else. Sometimes, we must
              process your information in order to comply with a statutory
              obligation.
            </p>
            <p>
              For example, we may be required to give information to legal
              authorities if they so request or if they have the proper
              authorisation such as a search warrant or court order.
            </p>
            <p>This may include your personal information.</p>
          </li>
        </ol>

        <h2 className="privacypolicy-h2-CSS">
          Specific uses of information you provide to us
        </h2>
        <ol className="privacypolicy-ol-CSS">
          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Complaints regarding content on our website
            </h3>
          </li>
          <p>
            If you complain about any of the content on our website, we shall
            investigate your complaint.
          </p>
          <p>
            If we feel it is justified or if we believe the law requires us to
            do so, we shall remove the content while we investigate.
          </p>
          <p>
            Free speech is a fundamental right, so we have to make a judgment as
            to whose right will be obstructed: yours, or that of the person who
            posted the content that offends you.
          </p>
          <p>
            If we think your complaint is vexatious or without any basis, we
            shall not correspond with you about it.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Sending a message to our support team
            </h3>
          </li>
          <p>
            When you contact us, whether by telephone, through our website or by
            e-mail, we collect the data you have given to us in order to reply
            with the information you need.
          </p>
          <p>
            We record your request and our reply in order to increase the
            efficiency of our [business / organisation].
          </p>
          <p>
            We do not keep any personally identifiable information associated
            with your message, such as your name or email address.
          </p>
          <p>OR</p>
          <p>
            We keep personally identifiable information associated with your
            message, such as your name and email address so as to be able to
            track our communications with you to provide a high quality service.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">Complaining</h3>
          </li>
          <p>
            When we receive a complaint, we record all the information you have
            given to us.
          </p>
          <p>We use that information to resolve your complaint.</p>
          <p>
            If your complaint reasonably requires us to contact some other
            person, we may decide to give to that other person some of the
            information contained in your complaint. We do this as infrequently
            as possible, but it is a matter for our sole discretion as to
            whether we do give information and if we do, what that information
            is.
          </p>
          <p>
            We may also compile statistics showing information obtained from
            this source to assess the level of service we provide, but not in a
            way that could identify you or any other person.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Affiliate and business partner information
            </h3>
          </li>
          <p>
            This is information given to us by you in your capacity as an
            affiliate of us or as a business partner.
          </p>
          <p>The information is not used for any other purpose.</p>
          <p>
            We undertake to preserve the confidentiality of the information and
            of the terms of our relationship.
          </p>
          <p>
            We expect any affiliate or partner to agree to reciprocate this
            policy.
          </p>
        </ol>

        <h2 className="privacypolicy-h2-CSS">
          Use of information we collect through automated systems when you visit
          our website
        </h2>
        <ol className="privacypolicy-ol-CSS">
          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">Cookies</h3>
          </li>
          <p>
            Cookies are small text files that are placed on your computer's hard
            drive by your web browser when you visit any website. They allow
            information gathered on one web page to be stored until it is needed
            for use on another, allowing a website to provide you with a
            personalised experience and the website owner with statistics about
            how you use the website so that it can be improved.
          </p>
          <p>
            Some cookies may last for a defined period of time, such as one day
            or until you close your browser. Others last indefinitely.
          </p>
          <p>
            Your web browser should allow you to delete any you choose. It also
            should allow you to prevent or limit their use.
          </p>
          <p>
            Our website uses cookies. They are placed by software that operates
            on our servers and by software operated by third parties whose
            services we use.
          </p>
          <p>
            When you first visit our website, we ask you whether you wish us to
            use cookies. If you choose not to accept them, we shall not use them
            for your visit except to record that you have not consented to their
            use for any other purpose.
          </p>
          <p>
            If you choose not to use cookies or you prevent their use through
            your browser settings, you will not be able to use all the
            functionality of our website.
          </p>
          <p>We use cookies in the following ways:</p>
          <ul className="privacypolicy-ul-CSS">
            <li>to track how you use our website</li>
            <li>
              to record whether you have seen specific messages we display on
              our website
            </li>
            <li>to keep you signed in to our website</li>
            <li>
              to record your answers to surveys and questionnaires on our site
              while you complete them
            </li>
            <li>
              to record the conversation thread during a live chat with our
              support team
            </li>
          </ul>
          <p>
            We provide more information about the cookies we use in our cookie
            policy.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Personal identifiers from your browsing activity
            </h3>
          </li>
          <p>
            Requests by your web browser to our servers for web pages and other
            content on our website are recorded.
          </p>
          <p>
            We record information such as your geographical location, your
            Internet service provider and your IP address. We also record
            information about the software you are using to browse our website,
            such as the type of computer or device and the screen resolution.
          </p>
          <p>
            We use this information in aggregate to assess the popularity of the
            webpages on our website and how we perform in providing content to
            you.
          </p>
          <p>
            If combined with other information we know about you from previous
            visits, the data possibly could be used to identify you personally,
            even if you are not signed in to our website.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">Our use of re-marketing</h3>
          </li>
          <p>
            Re-marketing involves placing a cookie on your computer when you
            browse our website in order to be able to serve to you an advert for
            our products or services when you visit some other website.
          </p>
          <p>
            We may use a third party to provide us with re-marketing services
            from time to time. If so, then if you have consented to our use of
            cookies, you may see advertisements for our products and services on
            other websites.
          </p>
        </ol>

        <h2 className="privacypolicy-h2-CSS">
          Disclosure and sharing of your information
        </h2>
        <ol className="privacypolicy-ol-CSS">
          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Information we obtain from third parties
            </h3>
          </li>
          <p>
            Although we do not disclose your personal information to any third
            party (except as set out in this notice), we sometimes receive data
            that is indirectly made up from your personal information from third
            parties whose services we use.
          </p>
          <p>No such information is personally identifiable to you.</p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Third party advertising on our website
            </h3>
          </li>
          <p>
            Third parties may advertise on our website. In doing so, those
            parties, their agents or other companies working for them may use
            technology that automatically collects information about you when
            their advertisement is displayed on our website.
          </p>
          <p>
            They may also use other technology such as cookies or JavaScript to
            personalise the content of and to measure the performance of their
            adverts.
          </p>
          <p>
            We do not have control over these technologies or the data that
            these parties obtain. Accordingly, this privacy notice does not
            cover the information practices of these third parties.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Access to your personal information
            </h3>
          </li>
          <ul className="privacypolicy-ul-CSS">
            <li>
              To obtain a copy of any information that is not provided on our
              website you may send us a request at{" "}
              <a
                className="privacypolicy-mail-CSS"
                href="mailto:example@gmail.com"
              >
                example@gmail.com
              </a>
              .
            </li>
            <li>
              After receiving the request, we will tell you when we expect to
              provide you with the information and whether we require any fee
              for providing it to you.
            </li>
          </ul>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Removal of your information
            </h3>
          </li>
          <p>
            If you wish us to remove personally identifiable information from
            our website, you may contact us at{" "}
            <a
              className="privacypolicy-mail-CSS"
              href="mailto:example@gmail.com"
            >
              example@gmail.com
            </a>
            .
          </p>
          <p>This may limit the service we can provide to you.</p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Verification of your information
            </h3>
          </li>
          <p>
            When we receive any request to access, edit or delete personal
            identifiable information we shall first take reasonable steps to
            verify your identity before granting you access or otherwise taking
            any action. This is important to safeguard your information.
          </p>
        </ol>

        <h2 className="privacypolicy-h2-CSS">Other matters</h2>
        <ol className="privacypolicy-ol-CSS">
          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">Use of site by children</h3>
          </li>
          <ul className="privacypolicy-ul-CSS">
            <li>
              We do not sell products or provide services for purchase by
              children, nor do we market to children.
            </li>
            <li>
              If you are under 18, you may use our website only with consent
              from a parent or guardian
            </li>
            <li>
              We collect data about all users of and visitors to these areas
              regardless of age and we anticipate that some of those users and
              visitors will be children.
            </li>
            <li>
              Such child users and visitors will inevitably visit other parts of
              the site and will be subject to whatever on-site marketing they
              find, wherever they visit.
            </li>
          </ul>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Encryption of data sent between us
            </h3>
          </li>
          <p>
            We use Secure Sockets Layer (SSL) certificates to verify our
            identity to your browser and to encrypt any data you give us.
          </p>
          <p>
            Whenever information is transferred between us, you can check that
            it is done so using SSL by looking for a closed padlock symbol or
            other trust mark in your browser's URL bar or toolbar.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">How you can complain</h3>
          </li>
          <ul className="privacypolicy-ul-CSS">
            <li>
              If you are not happy with our privacy policy or if you have any
              complaint then you should tell us by email. Our address{" "}
              <a
                className="privacypolicy-mail-CSS"
                href="mailto:example@gmail.com"
              >
                example@gmail.com
              </a>
              .
            </li>
            <li>
              If a dispute is not settled then we hope you will agree to attempt
              to resolve it by engaging in good faith with us in a process of
              mediation or arbitration.
            </li>
          </ul>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Retention period for personal data
            </h3>
          </li>
          <p>
            Except as otherwise mentioned in this privacy notice, we keep your
            personal information only for as long as required by us:
          </p>
          <ul className="privacypolicy-ul-CSS">
            <li>to provide you with the services you have requested;</li>
            <li>
              to comply with other law, including for the period demanded by our
              tax authorities;
            </li>
            <li>to support a claim or defence in court.</li>
          </ul>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">Compliance with the law</h3>
          </li>
          <p>
            Our privacy policy has been compiled so as to comply with the law of
            every country or legal jurisdiction in which we aim to do business.
            If you think it fails to satisfy the law of your jurisdiction, we
            should like to hear from you.
          </p>
          <p>
            However, ultimately it is your choice as to whether you wish to use
            our website.
          </p>

          <li className="privacypolicy-li-CSS">
            <h3 className="privacypolicy-h3-CSS">
              Review of this privacy policy
            </h3>
          </li>
          <p>
            We may update this privacy notice from time to time as necessary.
            The terms that apply to you are those posted here on our website on
            the day you use our website. We advise you to print a copy for your
            records.
          </p>
        </ol>

        <p className="privacypolicy-p-CSS">
          If you have any questions regarding our privacy policy, please{" "}
          <u>contact us</u>.
        </p>
        <p className="privacypolicy-p-CSS">
          <a
            className="privacypolicy-mail-CSS"
            href="mailto:example@gmail.com"
          >
            example@gmail.com
          </a>
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
